import {
  Box,
  Drawer,
  Grid,
  IconButton,
  makeStyles,
  Theme,
  Tooltip,
  Typography,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import MenuIcon from "@material-ui/icons/Menu";
import {useAppSelector} from "app/hooks";
import ICON_NO_WATCHED from "assets/img/icon_noWatched.png";
import ICON_WATCHED from "assets/img/icon_watched.png";
import VECTOR_CATEGORY from "assets/img/vector_category.png";
import clsx from "clsx";
import {LessonByUser} from "models/managerLesson";
import queryString from "query-string";
import React, {Fragment} from "react";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import {selectLessonListByUser} from "../../ListLesson/listLessonSlice";

export interface ListVideoRecommendProps {
  openDrawer: boolean;
  setOpenDrawer: (e: any) => void;
}

export default function ListVideoRecommend({openDrawer, setOpenDrawer}: ListVideoRecommendProps) {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const listLesson = useAppSelector(selectLessonListByUser);
  const useStyles = makeStyles((theme: Theme) => ({
    wrapper: {
      overflowY: "scroll",
      height: 700,
      backgroundColor: "#fff",
      marginLeft: 15,
      boxShadow: "-2px 2px 4px rgba(168, 168, 168, 0.4)",
      borderRadius: " 10px 0px 0px 10px",
      padding: "10px 0px 10px 15px",
    },
    container: {
      maxHeight: 140,
    },
    root: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },

    drawer: {
      width: "100%",
      flexShrink: 0,
    },
    drawerOpen: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      position: "initial",
    },
    drawerClose: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      position: "initial",
      width: "100%",
    },
    drawer__title: {
      fontWeight: 600,
      fontSize: 18,
      [theme.breakpoints.down("lg")]: {
        fontSize: 15,
      },
    },
    menu_icon: {
      color: "#28A5F4",
    },
    image: {
      width: "100%",
      maxHeight: 140,
      cursor: "pointer",
      objectFit: "cover",
      height: "100%",
    },
    content: {
      width: "100%",
      height: "100%",
      paddingBottom: 0,
      backgroundColor: "#F3F3F3",
    },
    content__date: {
      color: "#4F4F4F",
      [theme.breakpoints.down("lg")]: {
        fontSize: 13,
      },
    },
    content__category: {
      fontWeight: 700,
      fontSize: 15,
      marginRight: 5,
      [theme.breakpoints.down("lg")]: {
        fontSize: 13,
      },
    },
    content__lesson__name: {
      fontSize: 15,
      fontWeight: 700,
      margin: "8px 0",
      cursor: "pointer",
      maxHeight: "1.4rem",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      [theme.breakpoints.down("lg")]: {
        fontSize: 13,
        margin: "5px 0",
      },
      "&:hover": {
        color: "#28A5F4",
        transition: "color 0.3s linear",
      },
    },
    content__lesson__description: {
      maxHeight: "2.5rem",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      [theme.breakpoints.down("lg")]: {
        fontSize: 12,
      },
    },
    content__lesson__status__icon: {
      marginLeft: 20,
      "& >img": {
        width: 15,
        height: 15,
        marginRight: 5,
      },
    },
  }));
  const classes = useStyles();
  const location: any = useLocation();
  const querySearchDate = queryString.parse(location.search);
  return (
    <div className={classes.wrapper}>
      <Box className={classes.root}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={() => setOpenDrawer(!openDrawer)}
          edge="start"
        >
          {!openDrawer ? <ArrowBackIosIcon className={classes.menu_icon} /> : <MenuIcon />}
        </IconButton>
        {openDrawer && (
          <>
            <Typography variant="subtitle2" className={classes.drawer__title}>
              {t("home.detaillesson.danhsachbaihockhac")}
            </Typography>
            <div></div>
          </>
        )}
      </Box>
      <Drawer
        variant="permanent"
        anchor="right"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: openDrawer,
          [classes.drawerClose]: !openDrawer,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: openDrawer,
            [classes.drawerClose]: !openDrawer,
          }),
        }}
      >
        {listLesson?.content?.map((lesson: LessonByUser) => (
          <Box mb={2} key={lesson.id}>
            <Grid container className={classes.container}>
              <Grid item xs={openDrawer ? 4 : 12}>
                {!openDrawer ? (
                  <Tooltip title={lesson?.lession?.lessionName}>
                    <img
                      src={lesson?.lession?.attachment.urlThumbnail}
                      alt="LESSON"
                      className={classes.image}
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        navigate({
                          pathname: `/lesson/${lesson.lessionId}`,
                          search: `year=${querySearchDate.year}&month=${querySearchDate.month}&attachmentID=${lesson.lession.attachmentID}`,
                        })
                      }
                    />
                  </Tooltip>
                ) : (
                  <img
                    src={lesson?.lession?.attachment.urlThumbnail}
                    alt="LESSON"
                    className={classes.image}
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      navigate({
                        pathname: `/lesson/${lesson.lessionId}`,
                        search: `year=${querySearchDate.year}&month=${querySearchDate.month}&attachmentID=${lesson.lession.attachmentID}`,
                      })
                    }
                  />
                )}
              </Grid>

              {openDrawer && (
                <Grid item xs={8}>
                  <Box
                    className={classes.content}
                    style={{
                      backgroundColor: "#F3F3F3",
                    }}
                  >
                    <Box pl={2} p={1}>
                      <Box textAlign="right">
                        <Box display="flex" justifyContent="flex-end" alignItems="center">
                          <Typography variant="subtitle2" className={classes.content__category}>
                            {lesson?.lession?.lessionCategory?.name}
                          </Typography>

                          <img src={VECTOR_CATEGORY} alt="background" width="30px" height="20px" />
                        </Box>
                      </Box>

                      <Tooltip
                        disableHoverListener={lesson?.lession?.lessionName.length < 30}
                        title={
                          <Typography variant="subtitle2">
                            {lesson?.lession?.lessionName}
                          </Typography>
                        }
                      >
                        <Typography
                          variant="subtitle2"
                          className={classes.content__lesson__name}
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            navigate({
                              pathname: `/lesson/${lesson.lessionId}`,
                              search: `year=${querySearchDate.year}&month=${querySearchDate.month}&attachmentID=${lesson.lession.attachmentID}`,
                            })
                          }
                        >
                          {lesson?.lession?.lessionName}
                        </Typography>
                      </Tooltip>

                      <Tooltip
                        disableHoverListener={lesson?.lession?.lessionDescription.length < 30}
                        title={
                          <Typography variant="subtitle2">
                            {lesson?.lession?.lessionDescription}
                          </Typography>
                        }
                      >
                        <Typography
                          variant="subtitle2"
                          className={classes.content__lesson__description}
                        >
                          {t("home.detaillesson.mota")}: {lesson?.lession?.lessionDescription}
                        </Typography>
                      </Tooltip>
                      {/* )} */}
                      <Box pt={1} display="flex" alignItems="center">
                        <Typography variant="body1" className={classes.content__date}>
                          {String(lesson?.lession?.publishDate).slice(-2)}/
                          {String(lesson?.lession?.publishDate).slice(4, 6)}/
                          {String(lesson?.lession?.publishDate).slice(0, 4)}
                        </Typography>
                        <Box className={clsx(classes.root, classes.content__lesson__status__icon)}>
                          {lesson?.watched ? (
                            <Fragment>
                              <img src={ICON_WATCHED} alt="ICON_WATCHED" />
                              <Typography variant="subtitle2">
                                {t("home.detaillesson.daxem")}
                              </Typography>
                            </Fragment>
                          ) : (
                            <Fragment>
                              <img src={ICON_NO_WATCHED} alt="ICON_NO_WATCHED" />
                              <Typography variant="subtitle2">
                                {t("home.detaillesson.chuaxem")}
                              </Typography>
                            </Fragment>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        ))}
      </Drawer>
    </div>
  );
}
